export function filterEnum(val, enums) {
  return enums.filter(i => i.val === val)[0] || {}
}
